$(document).on('change', '#registration_service_billing_kind', function() {
  if ($(this).val() == "manual") {
    $('.billing-checked-container').addClass("d-none")
  } else {
    $('.billing-checked-container').removeClass("d-none")
  }
});